import { moveItemInArray } from "@angular/cdk/drag-drop";
import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup } from "@angular/forms";
import { ActivatedRoute, NavigationStart, Router } from "@angular/router";
import { ModalDismissReasons, NgbModal, NgbModalOptions } from "@ng-bootstrap/ng-bootstrap";

import { AuthService } from "src/app/_app-core/services/auth/auth.service";
import { DateUtilsService } from "src/app/_services/dateUtils";
import { PosService } from "src/app/_services/posService";
import { InvoiceService } from "./../../../../_services/invoice.service";

@Component({
  selector: "app-credit-note-upload-preview",
  templateUrl: "./credit-note-upload-preview.component.html",
  styleUrls: ["./credit-note-upload-preview.component.scss"],
})
export class CreditNoteUploadPreviewComponent implements OnInit {
  invoiceDetails: any;
  invoiceType: any;
  closeResult: string = "";
  modalOptions: NgbModalOptions;
  loading: boolean = false;
  invoiceSaved: boolean = false;
  uploadInvoice: boolean = false;
  uploadSuccessful: boolean = false;
  saving: boolean = false;
  displayName: any;
  hasError = false;
  pdfSrc: any;
  fileSizeError = false;
  fileTypeError = false;
  totalSizeError = false;
  typeError = false;
  sizeError = false;
  supportingDocuments: any[] = [];
  invoiceFile: any;
  invoiceDataToSave: any;
  isInvoiceChange: boolean = false;
  isUpdatedData: boolean = false;
  invoiceChanged: boolean = false;
  responseData: any;
  isCondensed: boolean = false;
  currentLayout = {
    isCondensed: true,
  };
  barcodeNo: any;
  poNo: any;
  eInvoice = false;
  servItems: any;
  eLoaderMsg = "";
  formSubmitted = false;
  previousUrl: any;
  files: File[];
  canSubmitForm = false;
  allDeleted = false;
  supportingDocsAdded = false;
  poType;
  companyCode = "";
  purchaseOrg;
  docType;
  isInvoice;
  poResponseData;
  poItems = [];
  documentType;
  intialLoading = false;
  isNonPOInvoice = false;
  invList: any;
  barcodeString: any;

  extractedNote = new FormGroup({
    invoiceType: new FormControl("e-invoice"),
    file: new FormControl(null),
    supportingFiles: new FormControl([]),
    fileSource: new FormControl(""),
    documentSource: new FormControl(""),
    terms_agreed: new FormControl(false),
  });
  invoices: any[] = [];

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private invoiceService: InvoiceService,
    private poService: PosService,
    private dateUtils: DateUtilsService,
    private authService: AuthService
  ) {
    this.modalOptions = {
      backdrop: "static",
      backdropClass: "customBackdrop",
      scrollable: true,
    };

    this.router.events.subscribe((val) => {
      if (val instanceof NavigationStart) {
        this.previousUrl = val.url;
      }
    });
  }

  toggleSidebar() {
    this.currentLayout.isCondensed = !this.currentLayout.isCondensed;
    document.body.setAttribute("data-sidebar-size", this.currentLayout.isCondensed ? "condensed" : "default");
  }

  canDeactivate() {
    if (!this.formSubmitted) {
      this.loading = true;
      return false;
    } else {
      return true;
    }
  }

  exitForm() {
    this.loading = false;
    this.formSubmitted = true;
    this.router.navigateByUrl(this.previousUrl);
  }

  cancelExit() {
    this.loading = false;
  }

  selectDocuments(event: any) {
    const MAX_FILE_SIZE = 25 * 1024 * 1024; // 25MB
    const MAX_TOTAL_SIZE = 100 * 1024 * 1024; // 100MB
    const ALLOWED_TYPES = ["application/pdf"];

    this.files = Array.from(event);
    // Calculate the total size of the selected files (in bytes)
    const totalSize = this.files.reduce((sum, file) => sum + file.size, 0);

    // Check if the total size exceeds 25 MB
    if (totalSize > MAX_TOTAL_SIZE) {
      this.totalSizeError = true;
      this.sizeError = false;
      this.typeError = false;
    }

    for (const file of this.files) {
      // Check if any individual file size exceeds 5 MB
      if (file.size > MAX_FILE_SIZE) {
        this.sizeError = true;
        this.typeError = false;
        this.totalSizeError = false;
        continue;
      }

      // Filter out any files that are not Word, Excel, or PDF
      if (!ALLOWED_TYPES.includes(file.type)) {
        this.typeError = true;
        this.sizeError = false;
        this.totalSizeError = false;
        continue;
      }
      this.supportingDocuments.push(file);
    }

    if (this.allDeleted === true) {
      if (this.extractedNote.get("terms_agreed").value === true) {
        this.extractedNote.patchValue({ terms_agreed: false });
      }
    } else {
      this.extractedNote.patchValue({ terms_agreed: false });
    }

    this.supportingDocsAdded = true;
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number) {
    this.supportingDocuments.splice(index, 1);

    if (this.supportingDocuments.length === 0) {
      if (this.extractedNote.get("terms_agreed").value === true) {
        this.extractedNote.patchValue({ terms_agreed: false });
      }

      this.canSubmitForm = false;
      this.allDeleted = true;
      this.supportingDocsAdded = false;
    }
  }

  checkSupportingDocuments() {
    if (this.supportingDocuments.length > 0 && this.extractedNote.get("terms_agreed").value === false) {
      this.canSubmitForm = true;
    } else {
      this.canSubmitForm = false;
    }
  }

  onDrop(event: any) {
    // Update the list order
    moveItemInArray(this.supportingDocuments, event.previousIndex, event.currentIndex);
  }

  reUploadInvoice(event: any) {
    if (event.length > 0) {
      const fileUploaded = event[0];

      //console.log(fileUploaded);

      if (fileUploaded.type !== "application/pdf") {
        this.hasError = false;
        this.fileSizeError = false;
        this.fileTypeError = true;
      } else if (fileUploaded.size > 25 * 1024 * 1024) {
        this.fileTypeError = false;
        this.hasError = false;
        this.fileSizeError = true;
      } else {
        this.fileSizeError = false;
        this.fileTypeError = false;

        if (typeof FileReader !== "undefined") {
          let reader = new FileReader();
          reader.onload = (e: any) => {
            this.pdfSrc = e.target.result;
            //console.log(this.pdfSrc);
          };
          let $file: any = fileUploaded;
          reader.readAsArrayBuffer($file);
        }

        this.extractedNote.patchValue({
          fileSource: fileUploaded,
        });

        this.hasError = false;
        this.isInvoiceChange = true;

        // Get data from localStorage similar to upload-preview
        const req = JSON.parse(localStorage.getItem("req"));

        // Create items array similar to upload-preview
        const items: any[] = [];
        if (req && req.items) {
          req.items.forEach((item: any) => {
            items.push({
              poNo: item.poNo || "",
              itemNo: item.itemNo || "",
              grn: item.grn || "",
            });
          });
        }

        // Create user data structure similar to upload-preview
        const userData = {
          req: {
            emailAddress: "",
            companyCode: req ? req.companyCode : "",
            purchaseOrg: req ? req.purchaseOrg : "",
            docType: req ? req.docType : "",
            items: items,
          },
        };

        this.loading = true;
        this.invoiceChanged = true;
        this.formSubmitted = true;

        // Create ledger structure similar to upload-preview
        const timestamp = Date.now();
        const ledger = [
          {
            docDate: this.invoiceDetails.invoice_date ? this.invoiceDetails.invoice_date.split("-").reverse().join("") : new Date().toISOString().split("T")[0].replace(/-/g, ""),
            dueDate: this.invoiceDetails.invoice_date ? this.invoiceDetails.invoice_date.split("-").reverse().join("") : new Date().toISOString().split("T")[0].replace(/-/g, ""),
            dueAmt: this.invoiceDetails.invoice_amount,
            docAmt: this.invoiceDetails.invoice_amount,
            docType: this.invoiceService.getNoteType() || "CN",
            poNo: this.poNo || "",
            docNo: this.invoiceDetails.invoice_number,
            timestamp: timestamp,
            currCode: "INR",
            status: "PENDING_SUBMISSION",
            supplierNm: localStorage.getItem("displayName"),
            docDetail: {
              docAmt: this.invoiceDetails.invoice_amount,
              docFormat: "e-invoice",
              docCat: "po_based",
              docGstin: this.invoiceDetails.gstin,
              irn: this.invoiceDetails.irn,
            },
            docRef: [
              {
                src: this.invoiceDetails.file_link || "",
              },
            ],
            lineItemDetail: items.map((item) => ({
              poLineNo: item.itemNo || "",
              grn: item.grn || "",
              grnNo: item.grn || "",
            })),
            supplierCode: localStorage.getItem("vendorCode"),
            cmpCode: userData.req.companyCode,
            purchaseOrg: userData.req.purchaseOrg,
            erpDocType: userData.req.docType,
          },
        ];

        const formData: any = new FormData();
        formData.append("sellerCode", this.authService.getSellerCode());
        formData.append("reqType", "payexap");
        formData.append("session", JSON.stringify({ sessionId: localStorage.getItem("eippSession") }));
        formData.append("action", "add");
        formData.append("ledger", JSON.stringify(ledger));

        this.eLoaderMsg = "Verifying QR Code";

        setTimeout(() => {
          this.eLoaderMsg = "Authenticating QR Code";
        }, 5000);
        setTimeout(() => {
          this.eLoaderMsg = "Extracting Data";
        }, 10000);
        setTimeout(() => {
          this.eLoaderMsg = "Validating Data";
        }, 15000);

        this.invoiceService.extractInvoice(formData).subscribe(
          (res) => {
            this.loading = false;
            this.invoiceChanged = false;
            this.formSubmitted = false;
            this.isUpdatedData = true;
            this.responseData = res;
            if (
              !(
                this.responseData.length !== 0 && this.responseData.status === "error"
              )
            ) {
              this.invoiceDetails = this.responseData;
            }
          },
          () => {
          }
        );
      }
    }
  }

  open(content: any) {
    this.modalService.open(content, this.modalOptions).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  onSubmit() {
    this.loading = true;
    this.uploadInvoice = true;
    this.saving = false;
    this.formSubmitted = true;

    // Get data from localStorage similar to upload-preview
    const pods: any = localStorage.getItem("pods");
    const convertPods = pods ? JSON.parse(pods) : [];

    const poItems: any = [];
    if (convertPods && convertPods.length > 0) {
      convertPods.forEach((p: any) => {
        if (p.docNo !== "" && typeof p.docNo !== "undefined") {
          poItems.push({
            poNo: p.poNo,
            itemNo: p.poLineNo,
            grn: p._id,
          });
        } else {
          poItems.push({
            poNo: p.poNo,
            itemNo: p.poLineNo,
            grn: "",
          });
        }
      });
    }

    var companyCode = "";
    var purchaseOrg = "";
    var docType = "";

    if (convertPods && convertPods.length > 0) {
      
      companyCode = convertPods[0].cmpCode;
      purchaseOrg = convertPods[0].purchaseOrg;
      docType = convertPods[0].erpDocType;
    } else {
      companyCode = localStorage.getItem("servCompanyCode");
      purchaseOrg = localStorage.getItem("servPurchaseOrg");
      docType = localStorage.getItem("servDocType");
    }
    

    const userData = {
      req: {
        emailAddress: this.invoiceDetails.email_address || "",
        companyCode: companyCode || this.invList[0].cmpCode,
        purchaseOrg: purchaseOrg || this.invList[0].purchaseOrg,
        docType: docType || this.invList[0].erpDocType,
        items: poItems,
        termsAgreed: true,
      },
    };

    if (this.isInvoiceChange === true) {
      this.invoiceFile = this.extractedNote.value.fileSource;
    } else {
      this.invoiceFile = this.invoiceService.getFileElement();
    }

    const fileOrder = [];
    this.supportingDocuments.forEach((file, index) => {
      const obj = {};
      obj[(index + 1).toString()] = file.name;
      fileOrder.push(obj);
    });

    // Create ledger structure similar to upload-preview

    const docCat = localStorage.getItem("selectionType") === "po" ? "po_based" : localStorage.getItem("invoiceType") === "poInvoice" ? "inv_based" : "non_po_based";
    
    const timestamp = Date.now();
    const ledger = [
      {
        docDate: this.dateUtils.formatDateString(this.invoiceDetails.invoice_date),
        dueDate: this.dateUtils.formatDateString(this.invoiceDetails.invoice_date),
        dueAmt: this.invoiceDetails.invoice_amount,
        docAmt: this.invoiceDetails.invoice_amount,
        docType: this.invoiceService.getNoteType() || "CN",
        poNo: localStorage.getItem("selectionType") === "po" ? this.poNo : localStorage.getItem("invoiceType") === "poInvoice" ? this.poNo : undefined,
        docNo: this.invoiceDetails.invoice_number,
        timestamp: String(timestamp),
        currCode: "INR",
        status: "PENDING_SUBMISSION",
        supplierNm: localStorage.getItem("displayName"),
        docDetail: {
          docAmt: this.invoiceDetails.invoice_amount,
          docFormat: this.invoiceService.getInvType() || "e-invoice",
          docCat: docCat,
          docGstin: this.invoiceDetails.gstin,
          irn: this.invoiceDetails.irn,
        },
        docRef: [
          {
            src: this.invoiceDetails.file_link || "",
          },
        ],
        lineItemDetail:
          // convertPods && convertPods.length > 0
          //   ? [
          //       {
          //         poLineNo: convertPods[0].poLineNo,
          //         grn: convertPods[0]._id,
          //         grnNo: convertPods[0].docNo,
          //       },
          //     ]
          //   :
          [],
        invDetails: this.invoices?.length > 0 ? this.invoices.map((inv) => ({
          barcode: inv.barcode,
        })) : [],
        supplierCode: this.servItems ? this.servItems.supplierCode[0] : localStorage.getItem("vendorCode"),
        cmpCode: userData.req.companyCode,
        purchaseOrg: userData.req.purchaseOrg,
        erpDocType: userData.req.docType,
      },
    ];

    // Use the same FormData structure as upload-preview
    const formData: any = new FormData();
    formData.append("sellerCode", this.authService.getSellerCode());
    formData.append("reqType", "payexap");
    formData.append("session", JSON.stringify({ sessionId: localStorage.getItem("eippSession") }));
    formData.append("action", "add");
    formData.append("ledger", JSON.stringify(ledger));

    if (this.supportingDocuments.length !== 0) {
      for (let i = 0; i < this.supportingDocuments.length; i++) {
        formData.append("supportingDocs", this.supportingDocuments[i]);
      }
    } else {
      formData.append("supportingDocs", this.supportingDocuments);
    }

    // for (const value of formData.values()) {
    //     console.log(value);
    // }

    if (!this.saving) {
      this.invoiceService.uploadInvoiceWithoutExtration(formData).subscribe(
        (res) => {
          this.responseData = res;

          if (this.responseData.status === "error") {
            this.loading = false;
            this.uploadInvoice = false;
            this.hasError = true;
            this.formSubmitted = false;
          } else {
            this.barcodeNo = this.responseData.barcode;

            this.uploadInvoice = false;
            this.invoiceSaved = false;
            this.uploadSuccessful = true;

            //console.log(this.responseData);
          }
        },
        (error) => {
          this.loading = false;
          this.uploadInvoice = false;
          this.uploadSuccessful = false;
          this.invoiceSaved = false;
          //console.log(error);
        }
      );
    }

    this.modalService.dismissAll();
  }

  fetchPoItems(poNo, poType) {
    this.intialLoading = true;
    if (poType === "SERV") {
      const userData = {
        poNo: poNo,
        action: "get",
        sellerCode: localStorage.getItem("vendorCode"),
        session: { sessionId: localStorage.getItem("eippSession") },
        isPOD: true,
      };

      this.poService.fetchPurchaseOrders(userData).subscribe(
        (res) => {
          this.poResponseData = res;
          if (this.poResponseData.status == "successful") {
            this.companyCode = this.poResponseData.pos[0].po_company_code;
            this.purchaseOrg = this.poResponseData.pos[0].po_purchase_org;
            this.docType = this.poResponseData.pos[0].po_doc_type;

            this.poResponseData.pos[0].line_items.forEach((p: any) => {
              this.poItems.push({
                poNo: poNo,
                itemNo: p.po_item_line,
                grn: "",
                grn_no: "",
              });
            });
            this.intialLoading = false;
          } else {
            this.intialLoading = false;
          }
        },
        () => {
          this.intialLoading = false;
        }
      );
    } else {
      const userData = {
        poNo: poNo,
        action: "list",
        sellerCode: localStorage.getItem("vendorCode"),
        session: { sessionId: localStorage.getItem("eippSession") },
        isPOD: true,
      };

      this.poService.fetchPurchaseOrders(userData).subscribe(
        (res) => {
          this.poResponseData = res;
          if (this.poResponseData.status == "successful") {
            this.companyCode = this.poResponseData.pods[0].po_company_code;
            this.purchaseOrg = this.poResponseData.pods[0].po_purchase_org;
            this.docType = this.poResponseData.pods[0].po_doc_type;

            this.poResponseData.pods.forEach((p: any) => {
              this.poItems.push({
                poNo: p.po_no,
                itemNo: p.po_item_line,
                grn: p._id,
                grn_no: p.grn_no,
              });
            });
            this.intialLoading = false;
          } else {
            this.intialLoading = false;
          }
        },
        () => {
          this.intialLoading = false;
        }
      );
    }
  }

  ngOnInit(): void {
    this.displayName = localStorage.getItem("displayName");
    this.invoiceDetails = this.invoiceService.getProcessedInvoice();
    this.invoices = JSON.parse(localStorage.getItem("invoiceList"));
    //localStorage.setItem("poNo", this.invoiceDetails.poNo);
    this.loadFile();
    this.formSubmitted = false;
    this.documentType = localStorage.getItem("document");
    // console.log(this.documentType);

    if (localStorage.getItem("selectionType") === "invoice") {
      let barcodes = [];
      this.invoices.forEach((inv) => {
        barcodes.push(inv.barcode);
      });

      if (barcodes.length === 1) {
        this.barcodeString = barcodes[0];
      } else {
        this.barcodeString = barcodes.join(", ");
      }
    }

    if (localStorage.getItem("selectionType") === "invoice") {
      this.isInvoice = true;
    }

    this.invList = JSON.parse(localStorage.getItem("invoiceList"));

    if (localStorage.getItem("selectionType") === "invoice") {
      //this.poNo = this.invList[0].poNo;
      if (localStorage.getItem("invoiceType") === "poInvoice") {
        this.poNo = this.invList[0].poNo;
      }
    } else {
      this.poNo = this.route.snapshot.params["itemNo"];
    }

    // console.log(this.invoiceDetails);

    // console.log(localStorage.getItem("invoiceType"));

    if (localStorage.getItem("invoiceType") === "poInvoice" || localStorage.getItem("selectionType") === "po") {
      this.poType = localStorage.getItem("poType");
      this.fetchPoItems(this.poNo, this.poType);
    }

    // Fetch POD data similar to upload-preview to populate servItems
    if (this.poNo) {
      const userData = {
        sortConfig: {
          field: "updateTime",
          order: "desc",
        },
        filters: [
          {
            key: "docType",
            value: "POD",
          },
          {
            key: "poNoNumberOrString",
            value: this.poNo,
          },
        ],
        pageSize: 10,
        pageNo: 1,
        sellercode: this.authService.getSellerCode(),
        isExport: false,
        linkFilters: [],
        isAP: true,
        isPOD: true,
      };

      this.poService.fetchPurchaseOrders(userData).subscribe(
        (res) => {
          this.responseData = res;
          if (this.responseData.length !== 0) {
            this.servItems = this.responseData.data.list[0];
          }
        },
        () => {
        }
      );
    }
  }

  closeSuccessDialog() {
    this.loading = false;
    this.router.navigateByUrl("/credit-notes");
  }

  resubmitInvoice() {
    const poNo = this.route.snapshot.params["itemNo"];
    this.router.navigate(["/submit-invoice", poNo]);
  }

  loadFile() {
    if (typeof FileReader !== "undefined") {
      let reader = new FileReader();
      reader.onload = (e: any) => {
        this.pdfSrc = e.target.result;
        //console.log(this.pdfSrc);
      };
      let $file: any = this.invoiceService.getFileElement();
      reader.readAsArrayBuffer($file);
    }
  }
}
